import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-everBlack\"><div class=\"flex md:py-260px pt-32 px-4 pb-36 home_banner\"><div class=\"max-w-1392px w-full mx-auto flex\"><div style=\"width:699px;\" class=\"text-white flex justify-center flex-col\"><div class=\"md:text-68px text-40px text-left font-inter-bold\"> Arweave All-In-One Web3 Infrastructure Provider </div><div class=\"md:text-xl text-14px mt-5 text-everWhite1 pr-6 md:pr-0\"> We provide Arweave-based infrastructures for anyone who wants to build on Web3 using everPay, Permaswap, PermaDAO, and the development tool: Web3Infra. We make developing on Web3 easy-to-do. </div></div></div></div></div>", 1)

import ProjectSideModule from '@/components/ProjectSideModule.vue'
import NewParadigm from '@/components/NewParadigm.vue'
import SolutionsVue from '@/components/SolutionsWeOffer.vue'
import Supporters from '@/components/Supporters.vue'
import Footer from '@/components/Footer.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(ProjectSideModule),
    _createVNode(NewParadigm),
    _createVNode(SolutionsVue),
    _createVNode(Supporters),
    _createVNode(Footer)
  ], 64))
}
}

})